module.exports = __webpack_public_path__ + "332f702f290dfce582eabf4388b1d57f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-62.png
// module id = 137
// module chunks = 0